/**
 * @generated SignedSource<<6eabe472e1cc912c31cc2434970ef879>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AppVisibility = "EVERYONE" | "ONLY_OWNER" | "OWNER_OR_ADMIN" | "%future added value";
export type AppVisibilitySectionQuery$variables = {
  appId: string;
};
export type AppVisibilitySectionQuery$data = {
  readonly viewer: {
    readonly appById: {
      readonly visibility: AppVisibility;
    } | null | undefined;
  };
};
export type AppVisibilitySectionQuery = {
  response: AppVisibilitySectionQuery$data;
  variables: AppVisibilitySectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppVisibilitySectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AppVisibilitySectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aa6a9a122e8bddd9e6dae82efd40a680",
    "id": null,
    "metadata": {},
    "name": "AppVisibilitySectionQuery",
    "operationKind": "query",
    "text": "query AppVisibilitySectionQuery(\n  $appId: ID!\n) {\n  viewer {\n    appById(id: $appId) {\n      visibility\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "75b2d8b1afce1d5747945bce3f1a7392";

export default node;
